import { RPCDocs } from "../../../services/rpc.js";
import { useCurrentUser } from "../../AuthWrapper2/hooks/useCurrentUser.js";
import { useRPCContext } from "../../../contexts/RPCContext.js";
import { UserBadgeWide } from "./UserBadgeWide.js";
import { useSessionStorage } from "../../../hooks/useSessionStorage.js";
import { useEffect, useState } from "react";
import { Icon, MultiSelect, Tabs } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdExpandLess, MdExpandMore } from "react-icons/md";
import { useUpdateEffect } from "ahooks";
//#region src/modules/Users/shared/SearchFilterUserActiveInactiveMultiSelect.tsx
var RoleElement = RPCDocs.Auth.GetIdentityInfo.v1.Roles;
var LIMIT = 25;
function SearchFilterUserActiveInactiveMultiSelect({ focused, label, onChange, onClearSelection, onClick, rolesFilter, selectMode = "multi", value }) {
	const [usersTab, setUsersTab] = useState("active");
	const [activeUsers, setActiveUsers] = useSessionStorage(`activeUsersFilter-${label}`);
	const [inactiveUsers, setInactiveUsers] = useSessionStorage(`inactiveUsersLogFilter-${label}`);
	const [totalOptions, setTotalOptions] = useState(0);
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const currentUser = useCurrentUser();
	const { rpcService } = useRPCContext();
	useEffect(() => {
		if (!value?.length) {
			setActiveUsers(void 0);
			setInactiveUsers(void 0);
		}
	}, [value]);
	useEffect(() => {
		setLoading(true);
		rpcService.Users.GetUsersList.v1.call({
			active: usersTab === "active",
			pagination: { limit: LIMIT },
			rolesFilter
		}).then(({ data }) => {
			setTotalOptions(data.total);
			setOptions(data.users);
		}).finally(() => setLoading(false));
	}, [usersTab]);
	const handleLoadOptions = (opts) => {
		if (opts?.additional && options.length < totalOptions) rpcService.Users.GetUsersList.v1.call({
			active: usersTab === "active",
			pagination: {
				limit: LIMIT,
				skip: options.length
			},
			rolesFilter,
			searchText: opts.text
		}).then(({ data }) => {
			setOptions((prevOptions) => [...prevOptions, ...data.users]);
		});
		else if (opts.text) rpcService.Users.GetUsersList.v1.call({
			active: usersTab === "active",
			pagination: { limit: LIMIT },
			rolesFilter,
			searchText: opts.text
		}).then(({ data }) => {
			setOptions(data.users);
		});
	};
	useUpdateEffect(() => {
		if (selectMode === "multi") onChange([...activeUsers || [], ...inactiveUsers || []]);
	}, [activeUsers, inactiveUsers]);
	return /* @__PURE__ */ jsxs("div", {
		className: "bg-surface-strong p-xs",
		children: [/* @__PURE__ */ jsxs("div", {
			onClick,
			className: "flex w-full justify-between font-bold hover:cursor-pointer",
			children: [/* @__PURE__ */ jsx("span", { children: label }), /* @__PURE__ */ jsx("span", { children: focused ? /* @__PURE__ */ jsx(Icon, { Icon: MdExpandLess }) : /* @__PURE__ */ jsx(Icon, { Icon: MdExpandMore }) })]
		}), focused && /* @__PURE__ */ jsx("div", {
			className: "pt-xs",
			onClick: (e) => e.stopPropagation(),
			children: currentUser.anp.roles.includes(RoleElement.Admin) ? /* @__PURE__ */ jsxs(Tabs, {
				currentKey: usersTab,
				onTabClick: setUsersTab,
				children: [/* @__PURE__ */ jsx(Tabs.Tab, {
					title: "Active",
					tabKey: "active",
					notifications: activeUsers?.length ? activeUsers?.length : void 0,
					children: /* @__PURE__ */ jsx(MultiSelect, {
						disabled: loading,
						disableSelectAll: true,
						loading,
						onChangeValue: (val) => {
							if (selectMode === "multi") setActiveUsers(val);
							else if (!!value?.length && !!val?.length) {
								const filtered = val.filter((_val) => value[0] !== _val);
								setActiveUsers([filtered[0]]);
								setInactiveUsers(void 0);
								onChange([filtered[0]]);
							} else {
								setActiveUsers([val[0]]);
								setInactiveUsers(void 0);
								onChange([val[0]]);
							}
						},
						loadOptions: handleLoadOptions,
						onClearSelection,
						options,
						optionLabelExtractor: (option) => option.displayName,
						optionValueExtractor: (option) => option.id,
						placeholder: "Active Users",
						renderOption: (user) => /* @__PURE__ */ jsx(UserBadgeWide, {
							user,
							size: "sm"
						}),
						totalOptions,
						value: activeUsers || []
					})
				}), /* @__PURE__ */ jsx(Tabs.Tab, {
					title: "Inactive",
					tabKey: "inactive",
					notifications: inactiveUsers?.length ? inactiveUsers?.length : void 0,
					children: /* @__PURE__ */ jsx(MultiSelect, {
						disabled: loading,
						disableSelectAll: true,
						loading,
						onChangeValue: (val) => {
							if (selectMode === "multi") setInactiveUsers(val);
							else if (!!value?.length && !!val?.length) {
								const filtered = val.filter((_val) => value[0] !== _val);
								setActiveUsers(void 0);
								setInactiveUsers([filtered[0]]);
								onChange([filtered[0]]);
							} else {
								setActiveUsers(void 0);
								setInactiveUsers(val);
								onChange(val);
							}
						},
						loadOptions: handleLoadOptions,
						onClearSelection,
						options,
						optionLabelExtractor: (option) => option.displayName,
						optionValueExtractor: (option) => option.id,
						placeholder: "Inactive Users",
						renderOption: (user) => /* @__PURE__ */ jsx(UserBadgeWide, {
							user,
							size: "sm"
						}),
						totalOptions,
						value: inactiveUsers || []
					})
				})]
			}) : /* @__PURE__ */ jsx(MultiSelect, {
				disabled: loading,
				disableSelectAll: true,
				loading,
				onChangeValue: (val) => {
					setActiveUsers(val);
				},
				loadOptions: handleLoadOptions,
				onClearSelection,
				options,
				optionLabelExtractor: (option) => option.displayName,
				optionValueExtractor: (option) => option.id,
				placeholder: "Active Users",
				renderOption: (user) => /* @__PURE__ */ jsx(UserBadgeWide, {
					user,
					size: "sm"
				}),
				totalOptions,
				value: activeUsers || []
			})
		})]
	});
}
//#endregion
export { SearchFilterUserActiveInactiveMultiSelect };

//# sourceMappingURL=SearchFilterUserActiveInactiveMultiSelect.js.map